import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Subject } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UsersService {
  userDetails: any;
  // tokenDetails: any;
  isUserLoggedIn = false;
  public userInfo = new Subject<any>();
  webMessage: any;
  getServertime: any;
  username: string;
  pwd: string;

  constructor(
    private api: ApiService,
    private http: HttpClient,
    public router: Router) { }

  refreshToken(path?: string): any {
    return new Promise((resolve, reject) => {
      this.api.getWithOutLang(`/getdate`).subscribe((res: any) => {
        this.getServertime = res.map._date;
        this.http.get(`${environment.endpoint}/${'getJwt'}`, { headers: this.iudgetHeaders('/getJwt') }).subscribe((res: any) => {
          if (res) {
            const username = this.api.decrypt(res.username).split("~");
            const pswd = this.api.decrypt(res.password).split("~");
            const obj = {
              username: username[0],
              password: pswd[0]
            }
            const obj1 = {
              username: this.api.encrypt(obj.username, this.getServertime),
              password: this.api.encrypt(obj.password, this.getServertime)
            }
            let options = {
              headers: this.getCustomHeaders()
            };
            this.http.post(`${environment.endpoint}${`/authenticate`}`, obj1, options).subscribe((res:any) => {
              console.log(`res`, res);
              if (res) {
                localStorage.setItem(`token`, res.token);
                resolve(res);
              } else {
                reject(this.signOut());
              }
            });
          }
        });
      });
    })
  }

  getCustomHeaders(): HttpHeaders {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('_url', '/authenticate');
    return headers;
  }

  signOut() {
    this.router.navigateByUrl(`/auth`);
  }

  isLoggedIn() {
    let id: any = null;
    if (localStorage.getItem('vprpinfo')) {
      if (localStorage.getItem(`fromPage`) == 'forgot') {
        id = localStorage.getItem('vprpinfo');
      } else if (localStorage.getItem('vprpinfo') && sessionStorage.getItem('vprpinfo')) {
        id = sessionStorage.getItem('vprpinfo');
      }
      return id ? true : false;
    } else {
      id = null;
      localStorage.clear();
      sessionStorage.clear();
      return false;
    }
  }

  getMessage(val) {
    return new Promise((resolve, reject) => {
      let response = ''
      this.api.get(`/getMessagedesclist?`).subscribe(res => {
        this.webMessage = res[0];
        // console.log('filer', res[0].filter(item => item.msg_code.charAt(1) == 'B'))  
        for (let i = 0; i < this.webMessage.length; i++) {
          if (this.webMessage[i].msg_code == val) {
            response = this.webMessage[i].msg_desc;
            resolve(response)
            return
          }
        }
      });
    });
  }

  getErrorMessage(val) {
    const getError = localStorage.getItem('WebMessage');
    const erroeMessage = JSON.parse(getError);
    return new Promise((resolve, reject) => {
      let response = '';
      for (let i = 0; i < erroeMessage.length; i++) {
        if (erroeMessage[i].msg_code == val) {
          response = erroeMessage[i].msg_desc;
          resolve(response)
          return
        }
      }
    });
  }

  // getDatefromServer(){
  //   this.api.getWithOutLang(`/getdate`).subscribe((res:any) => {  
  //     this.getServertime = res.map._date;
  //     this.username = environment._User;
  //     this.pwd = environment._Pwd
  //   })
  // }

  iudgetHeaders(url) {
    let headerValue = {};
    const token = localStorage.getItem(`token`);

    headerValue = {
      'Content-Type': 'application/json',
      'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
      'X-Tenant-Identifier': 'dynamic_lokos',
      'Authorization': token ? 'Bearer ' + token : '',
      'Cache-Control': 'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
      // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
      // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
      // "X-Content-Type-Options": "nosniff",
      "X-Frame-Options": "DENY",
      // "X-XSS-Protection": "1; mode=block",
      '_url': url,
      '_user_token': '',
      'userCode': '',
      'roleCode': '',
      'blockCode': '',
    }

    return new HttpHeaders(headerValue);
  }
}
